import Genre from '../../classes/genre';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGenreState } from '../../types/interfaces/states';
import { RootState } from '../store';

const initialState: IGenreState = {
  data: undefined,
};

const genresSlice = createSlice({
  name: 'genres',
  initialState,
  reducers: {
    updateGenres: (state, action: PayloadAction<Genre[]>) => {
      state.data = action.payload;
    },
  },
});

const { actions, reducer: genresReducer } = genresSlice;
export const { updateGenres } = actions;
export const genresSelector = (state: RootState) => state.genres;
export default genresReducer;
